import axios from 'axios'

const api = axios.create({ baseURL: '/api/public/v1' })

export async function fetchCatalog() {
  const { data } = await api.get('/catalog')
  return data.products
}

export async function fetchProduct(slug) {
  const { data } = await api.get(`/products/${slug}`)
  return data.product
}
